export default "__VITE_ASSET__e996c901__"